import { ref, onMounted } from 'vue'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

export function useDeviceId() {
    const deviceId = ref<string>('')

    const loadDeviceId = async () => {
        const fp = await FingerprintJS.load()
        const result = await fp.get()
        deviceId.value = result.visitorId
        return result.visitorId
    }

    onMounted(async () => {
        await loadDeviceId()
    })

    return { deviceId, loadDeviceId }
}

// 直接获取设备ID的异步函数
export async function getDeviceId(): Promise<string> {
    const fp = await FingerprintJS.load()
    const result = await fp.get()
    return result.visitorId
}